import classnames from 'classnames';
import React, { CSSProperties } from 'react';
import { Submittal, SubmittalOrderedMap } from 'records/Submittal';

interface Props {
  selectedSpecNumber: string;
  onSelectSpecNumber: (nextSpecNumber: string) => void;
  style: CSSProperties;
  submittal: SubmittalOrderedMap;
}

const ApproveSubmittalFolder: React.VFC<Props> = ({
  selectedSpecNumber,
  submittal,
  onSelectSpecNumber,
  style,
}) => {
  const docsCount = submittal
    .valueSeq()
    .flatMap((s) => s.attachments)
    .flatten()
    .toList().size;

  const firstApprovedSub = submittal.first<Submittal>();
  const submittalNumber = firstApprovedSub.specsectionnumber;

  const isSelected = firstApprovedSub.specsectionnumber === selectedSpecNumber;

  return (
    <div
      className={classnames(
        'p3 bb-3 cursor-pointer bgd-primary-blue-opacity-10-h',
        {
          'bgd-white-2': !isSelected,
          'bgd-primary-blue-opacity-10': isSelected,
        }
      )}
      style={{ ...style, height: '64px' }}
      onClick={() => onSelectSpecNumber(submittalNumber)}
    >
      <div className="row mb2 justify-between">
        <div className="bold size-20 black-2">{submittalNumber}</div>
        <div className="py1 px3 flex-center bgd-white-2 b-solid b-light-grey-1 b-radius-3 size-14 black-1 b-width-1">
          {docsCount}
        </div>
      </div>

      <div className="light size-14 truncate">
        {firstApprovedSub.specsectionname}
      </div>
    </div>
  );
};

export default ApproveSubmittalFolder;
